import { ModelBase } from '../../core/model/model-base';
import { Account } from '../../accounting/model/account';

export class PaymentMethod extends ModelBase {
  constructor() {
    super();
  }

  name: string;
  requiresCompanyBankAccount: boolean;

  toJSON() {
    return this;
  }
}
